import { CloudUnstakeInfo } from './cloud';
import { ThirdUnstakeInfo } from './third';
import { useWallet } from '@/hooks/wallet';
import { ShowType } from '@/types/account';

import styles from './index.module.scss';

interface Props {
  onChangeShowType: (v: ShowType) => void;
  showType: ShowType;
}

export const UnstakeInfo = (props: Props) => {
  const { onChangeShowType, showType } = props;
  const { isThird } = useWallet();

  return (
    <div className={styles.container}>
      {isThird && (
        <ThirdUnstakeInfo
          onChangeShowType={onChangeShowType}
          showType={showType}
        />
      )}
      {!isThird && (
        <CloudUnstakeInfo
          showType={showType}
          onChangeShowType={onChangeShowType}
        />
      )}
    </div>
  );
};
